import styled from "styled-components";

export const StyledTableContainer = styled.div`
	& button {
		margin-top: 5rem;
	}
`;

export const StyledTableSearch = styled.div`
	margin-bottom: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	& form {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	& > * {
		width: 40rem;
	}
`;

export const StyledTableHeader = styled.div`
	margin-bottom: 1rem;
	padding: 1.1rem 2rem;

	background-color: #dde5ef;
	border-bottom: 1px solid #4d6382;

	display: flex;
	align-items: center;

	& > span {
		width: 92.3%;

		color: #283239;
		font-size: 1.2rem;
		font-weight: 500;

		display: block;
	}

	& > span:nth-child(2) {
		width: 7.7%;
	}
`;

export const StyledTable = styled.div`
	margin: 0.4rem 0;
	padding: 0.6rem 1.8rem;

	display: flex;
	align-items: center;
	justify-content: space-between;

	background-color: #ffffff;

	& span {
		font-size: 1.4rem;
		font-weight: 300;
	}

	& > span {
		width: 91.3%;
		overflow: hidden;
	}

	& input {
		width: 80rem;
		margin-bottom: 0;
	}

	& div {
		width: 7.7%;

		display: flex;
		align-items: center;

		& img {
			height: 1.6rem;
			margin-right: 1.6rem;

			cursor: pointer;
		}
	}
`;
